/**
 * The install text for the packaged integrations, shared by Settings → Agent keys and by
 * scripts/build-integrations.mjs so the product and the generated files name the same server, the same
 * environment variable, and the same plugin id. The key itself is never here: the person's created key
 * is substituted at render time, and the committed files only carry the LOOPGROUP_KEY placeholder.
 */

export const LOOPGROUP_MCP_URL = "https://loopgroup.ai/mcp";

/** The environment variable both integrations read the bearer key from. */
export const LOOPGROUP_KEY_ENV = "LOOPGROUP_KEY";

/** The GitHub marketplace (owner/repository) and the plugin id inside it. */
export const CLAUDE_PLUGIN_INSTALL = { marketplace: "tonacy/loopgroup", plugin: "loopgroup@loopgroup" } as const;

/** Where the Codex skill folder goes. */
export const CODEX_SKILL_PATH = "~/.codex/skills/loopgroup";

/** The three commands a person runs to install the Claude Code plugin; the key is the one they just created. */
export function claudeCodeInstallCommands(token: string): string {
  return [
    `claude plugin marketplace add ${CLAUDE_PLUGIN_INSTALL.marketplace}`,
    `claude plugin install ${CLAUDE_PLUGIN_INSTALL.plugin}`,
    `export ${LOOPGROUP_KEY_ENV}=${token}`,
  ].join("\n");
}

/**
 * The block a person appends to ~/.codex/config.toml. Codex CLI reads the key from the named environment
 * variable (`bearer_token_env_var`) and sends it as the bearer header, so the config file never holds it.
 */
export const CODEX_MCP_CONFIG = `[mcp_servers.loopgroup]
url = "${LOOPGROUP_MCP_URL}"
bearer_token_env_var = "${LOOPGROUP_KEY_ENV}"`;
